import React from 'react';

const AboutStats: React.FC = () => (
  <section className="py-24 md:py-32 bg-[#FAF8F5]">
    <div className="container-main grid grid-cols-2 lg:grid-cols-4 gap-6">
      {[
        { value: '10+', label: 'Years Experience', bg: 'bg-white', text: 'text-primary' },
        { value: '3,000+', label: 'Products Available', bg: 'bg-primary', text: 'text-white' },
        { value: 'Africa', label: 'Wide Distribution', bg: 'bg-white', text: 'text-primary' },
        { value: '100%', label: 'CE & FDA Approved', bg: 'bg-primary', text: 'text-white' },
      ].map((s, i) => (
        <div key={i} className={`${s.bg} rounded-2xl p-8 shadow-sm border ${s.bg === 'bg-white' ? 'border-gray-100' : 'border-primary-dark'} text-center`}>
          <div className={`text-3xl font-extrabold ${s.text} mb-2`}>{s.value}</div>
          <div className={`${s.text} opacity-70 text-xs uppercase tracking-wider font-semibold`}>{s.label}</div>
        </div>
      ))}
    </div>
  </section>
);

export default AboutStats;
